<template>
  <svg
    width="69"
    height="68"
    viewBox="0 0 69 68"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="ic_consult">
      <path
        id="Rectangle 3455"
        d="M18.7517 14.3113C18.8917 12.4438 20.4478 11 22.3206 11H46.6794C48.5522 11 50.1083 12.4438 50.2483 14.3113L52.7115 47.1534C52.8672 49.2296 51.2246 51 49.1426 51H19.8574C17.7754 51 16.1328 49.2296 16.2885 47.1534L18.7517 14.3113Z"
        fill="url(#paint0_radial_2578_441)"
      />
      <path
        id="Rectangle 3456"
        d="M11.7933 48.4232C11.9667 47.594 12.6978 47 13.5449 47H55.4551C56.3022 47 57.0333 47.594 57.2067 48.4232L58.5493 54.8443C58.7817 55.9559 57.9333 57 56.7977 57H12.2023C11.0667 57 10.2183 55.9559 10.4507 54.8443L11.7933 48.4232Z"
        fill="#E9E9EC"
      />
      <rect
        id="Rectangle 2884"
        x="36.5"
        y="40"
        width="4"
        height="5"
        transform="rotate(-180 36.5 40)"
        fill="white"
      />
      <rect
        id="Rectangle 2885"
        x="36.5"
        y="32"
        width="4"
        height="13"
        transform="rotate(-180 36.5 32)"
        fill="white"
      />
      <path
        id="Line 5"
        d="M13 28.5049L4 28.5049"
        stroke="url(#paint1_linear_2578_441)"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        id="Line 8"
        d="M56.0938 28.5049L65.0938 28.5049"
        stroke="url(#paint2_linear_2578_441)"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        id="Line 6"
        d="M13.5581 35.1655L6.46436 38.8855"
        stroke="url(#paint3_linear_2578_441)"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        id="Line 9"
        d="M55.5356 35.1655L62.6294 38.8855"
        stroke="url(#paint4_linear_2578_441)"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        id="Line 7"
        d="M13.5581 21.8345L6.46436 18.1145"
        stroke="url(#paint5_linear_2578_441)"
        stroke-width="2"
        stroke-linecap="round"
      />
      <path
        id="Line 10"
        d="M55.5356 21.8345L62.6294 18.1145"
        stroke="url(#paint6_linear_2578_441)"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <radialGradient
        id="paint0_radial_2578_441"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(34.5 31) rotate(90) scale(20 18.5)"
      >
        <stop stop-color="#F1636F" />
        <stop
          offset="1"
          stop-color="#F7A4AB"
        />
      </radialGradient>
      <linearGradient
        id="paint1_linear_2578_441"
        x1="13"
        y1="27.0049"
        x2="4"
        y2="27.0049"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#F6C375"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#F6C375"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2578_441"
        x1="56.0938"
        y1="27.0049"
        x2="65.0938"
        y2="27.0049"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#F6C375"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#F6C375"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_2578_441"
        x1="12.8615"
        y1="33.8372"
        x2="5.76779"
        y2="37.5572"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#F6C375"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#F6C375"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_2578_441"
        x1="56.2322"
        y1="33.8372"
        x2="63.326"
        y2="37.5572"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#F6C375"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#F6C375"
        />
      </linearGradient>
      <linearGradient
        id="paint5_linear_2578_441"
        x1="12.8615"
        y1="23.1628"
        x2="5.76779"
        y2="19.4428"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#F6C375"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#F6C375"
        />
      </linearGradient>
      <linearGradient
        id="paint6_linear_2578_441"
        x1="56.2322"
        y1="23.1628"
        x2="63.326"
        y2="19.4428"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stop-color="#F6C375"
          stop-opacity="0.5"
        />
        <stop
          offset="1"
          stop-color="#F6C375"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
